import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M11.9999 20.4998C14.0771 20.4998 15.9803 19.7547 17.4568 18.5171L15.177 16.2373C13.3003 17.6481 10.6998 17.6481 8.82308 16.2375L6.54325 18.5173C8.01968 19.7548 9.92278 20.4998 11.9999 20.4998ZM7.76242 15.1768C6.35178 13.3001 6.35184 10.6995 7.76261 8.82291L5.4827 6.543C4.24514 8.01946 3.5 9.92266 3.5 11.9999C3.5 14.0771 4.24509 15.9802 5.48258 17.4567L7.76242 15.1768ZM8.82334 7.76231L6.54339 5.48237C8.0198 4.245 9.92285 3.5 11.9999 3.5C14.0771 3.5 15.9802 4.24509 17.4567 5.48258L15.1767 7.76252C13.3002 6.35201 10.6999 6.35194 8.82334 7.76231ZM16.2374 8.82318C17.6479 10.6997 17.648 13.3 16.2376 15.1766L18.5174 17.4565C19.7548 15.98 20.4998 14.077 20.4998 11.9999C20.4998 9.92278 19.7548 8.01967 18.5173 6.54324L16.2374 8.82318ZM11.9999 21.9998C17.5227 21.9998 21.9998 17.5227 21.9998 11.9999C21.9998 6.47711 17.5227 2 11.9999 2C6.47711 2 2 6.47711 2 11.9999C2 17.5227 6.47711 21.9998 11.9999 21.9998ZM9.31614 14.6838C7.83394 13.2016 7.83394 10.7984 9.31614 9.31624C10.7983 7.83404 13.2015 7.83404 14.6837 9.31624C16.1659 10.7984 16.1659 13.2016 14.6837 14.6838C13.2015 16.166 10.7983 16.166 9.31614 14.6838Z',
                    fill: '#82869E',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const CustomerSupportOutlined = React.forwardRef(IconComponent);
CustomerSupportOutlined.displayName = 'CustomerSupportOutlined';

export { CustomerSupportOutlined };
